import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { BackgroundImage, } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import Swiper from 'swiper';
import Videojs from "../video-js";
import moment from 'moment-timezone';
import { gtag } from "../../utils";
import "./style.scss";

const LogoSlide = ({ page, lang, rendering, fields }) => {
  const  { list, logo, duration, startTime } = fields
  const rootEl = useRef()
  const swiper = useRef(null)
  const swiperEl = useRef(null)
  const isMobile = mobileIs()
  let timer = null;
  const resultRef = useRef([])
  const [showPage, setShowPage] = useState(true)
  const liveStartTIme = new Date(moment(new Date(startTime?.value)).format('YYYY/MM/DD HH:mm:ss'));
  const nowTIme =  new Date(moment(new Date()).format('YYYY/MM/DD HH:mm:ss'));

  const buildSwiper = () => {
    const options = {
      watchSlidesProgress: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: list.length > 1,
      // autoplay: duration?.value ?  duration?.value === 0 ? false : {
      //   disableOnInteraction: false,
      //   delay: duration.value * 1000,
      // } : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  const playVideo = () => {
    if(resultRef.current && resultRef.current.length > 0) {
      if( resultRef.current[0]){
        resultRef.current[0].player.play(0)
      }
    }
  }
  
  useEffect(() => {
    if( startTime.value === '0001-01-01T00:00:00Z'){
      setShowPage(true)
    }else{
      if(parseInt(nowTIme - liveStartTIme) / 1000 > 0 ){
        setShowPage(false)
        // console.log('直播了')
      }
      if(parseInt(nowTIme - liveStartTIme) / 1000 < 0){
        // console.log('未播放')
        let count =( liveStartTIme - nowTIme )/1000;
        timer = setInterval(v=>{
          count --;
          console.log(`${count}秒后播放`)
          if(count === 0 ){
            setShowPage(false)
            clearInterval(timer)
          }
        },1000)
      }
    }
	if(parseInt(nowTIme - liveStartTIme) / 1000 < 0 || startTime?.value === '0001-01-01T00:00:00Z') {
		setTimeout(function(){
		  buildSwiper()
		},100)
		setTimeout(function(){
		  playVideo()
		},1000)
		// 1s以后执行logo渐入动画
		let logoDom = document.querySelector('.c-logo-slide-logo')
		setTimeout((e) => {
		  if(!logoDom) { return false }
		  logoDom.setAttribute('class', 'c-logo-slide-logo active')
		  setTimeout((e) => {
			logoDom.setAttribute('class', 'c-logo-slide-logo hide')
			setTimeout((e) => {
			  logoDom.style.display = 'none'
			}, 600)
		  }, 700)
		  setTimeout((e) => {
			document.querySelector('.mask-t').style.height = '0'
			document.querySelector('.mask-b').style.height = '0'
			let carDoms = document.querySelectorAll('.car-image')
			for(let i=0; i<carDoms.length; i++) {
			  carDoms[i].style.transform = 'scale(1)'
			}
			setTimeout((e) => {
			  let textDoms = document.querySelectorAll('.text')
				let descDoms = document.querySelectorAll('.descripition')
			  let btnDoms = document.querySelectorAll('.btn-content')
			  for(let i=0; i<textDoms.length; i++) {
					textDoms[i].setAttribute('class', 'text active')
			  }
				for(let i=0; i<descDoms.length; i++) {
					descDoms[i].setAttribute('class', 'descripition active')
				}
			  for(let i=0; i<btnDoms.length; i++) {
				btnDoms[i].setAttribute('class', 'btn-content active')
			  }
			}, 1000)
		  }, 600)
		}, 1000)
	}
  }, [])
  
  const btnClick = (item) => {
    gtag('event', 'Component_info', {
      'component_name': 'LogoSlide',
      'page_title': page?.name
    });
  }
  const rootClasses = classNames("c-logo-slide", getOverallSettingsClasses(fields));
  return (
    <>
    
		{showPage && 
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-logo-slide-content" ref={rootEl}>
        <BackgroundImage {...logo}  className="c-logo-slide-logo" />
        <div className="swiper-content">
          <div className="c-logo-slide_swiper swiper" ref={swiperEl}>
				    <div className="swiper-wrapper">
              {list && list.map((item, index) => (
                <div className="swiper-slide" key={index}>
                  {!isMobile && !item?.fields?.pc_video?.value && <BackgroundImage {...item.fields.pc_image} className={classNames("car-image", item?.fields?.image_align ? `bg-${item.fields.image_align.fields.phrase.value}` : "")} />}
                  {isMobile && !item?.fields?.m_video?.value && <BackgroundImage {...item.fields.m_image} className={classNames("car-image", item?.fields?.image_align ? `bg-${item.fields.image_align.fields.phrase.value}` : "")} />}
                  {!isMobile && item?.fields?.pc_video?.value && <Videojs
                    ref={e => resultRef.current.push(e)}
                    {...{
                      sources: [
                        {
                          src: item?.fields?.pc_video?.value?.src,
                          type: item?.fields?.pc_video?.value?.mimeType
                        }
                      ],
                      controls: false,
                      autoplay: true,
                      loop: true,
                      muted: true,
                      poster: item?.fields?.pc_image?.value ? item?.fields?.pc_image?.value?.src : ""
                    }}
                  />}
                  {isMobile && item?.fields?.m_video?.value && <Videojs
                    ref={e => resultRef.current.push(e)}
                    {...{
                      sources: [
                        {
                          src: item?.fields?.m_video?.value?.src,
                          type: item?.fields?.m_video?.value?.mimeType
                        }
                      ],
                      controls: false,
                      autoplay: true,
                      loop: true,
                      muted: true,
                      poster: item?.fields?.m_image?.value ? item?.fields?.m_image?.value?.src : ""
                    }}
                  />}
                  <div className="btn-text-content">
                    {!isMobile && <RichText tag="div" className="text" field={item?.fields?.pc_text} />}
										{!isMobile && <RichText tag="div" className="descripition" field={item?.fields?.pc_descripition} />}
                    {isMobile && <RichText tag="div" className="text" field={item?.fields?.m_text} />}
										{isMobile && <RichText tag="div" className="descripition" field={item?.fields?.m_descripition} />}
                    <div className="btn-content">
                      {item?.fields?.buttonlist && item?.fields?.buttonlist?.length > 0 && item?.fields?.buttonlist.map((item, index) => {
                        return <div className="primary-button-in" key={index}  onClick={e => btnClick(item.fields)} >
                          <PrimaryButton {...(item.fields)} />
                        </div>
                      })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {list && list.length > 1 && <div className="swiper-pagination"></div>}
          </div>
          <div className="mask-t"></div>
          <div className="mask-b"></div>
        </div>
      </div>
    </div>
    }
    </>
  )
};
export default LogoSlide;
